import route from "@/router/index";
import {ACCESS_TOKEN_NAME, AUTHORRITIES_NAME, USER_NAME} from "@/constant";
import securityCfg from "@/security/config";

const security = (function(router) {
    let userName;
    let authorities;
    let authorizationMapper;
    let authenSuccesUrlRedirect;

    let initAuthorities = function() {
        let authoritiesStore = getAuthoritiesStore();
        authorities = new Map();
        for(let element of authoritiesStore) {
            let author = element.authority;
            authorities.set(author, author);
        }
    }

    let initAuthorizationMapper = function() {
        authorizationMapper = [];
        cloneObjConfig(securityCfg.authorizationMapper, authorizationMapper);
    }

    let initAuthenSuccesUrlRedirect = function() {
        authenSuccesUrlRedirect = securityCfg.authenSuccesUrlRedirect(hasAuthor);
    }

    let initConfig = function() {
        initAuthorizationMapper();
        initAuthenSuccesUrlRedirect();
    }

    let initRouteFilter = function() {
        router.beforeEach((to, from, next) => {
            let _isLogin = isLogin();
            let _fullPath = to.fullPath;
            let _isAuthorized = isAuthorized(_fullPath);
            if(!_isLogin && _fullPath === "/") {
                next({name : 'UserLogin'});
            } else if(_isLogin && (_fullPath === "/" || _fullPath === "/login.html")) {
                next(authenSuccesUrlRedirect);
            } else if(_isAuthorized) {
                next();
            } else if(!_isLogin) {
                next({
                name: 'UserLogin'})
            } else {
                next({name: 'page403'});
            }
        });
    }

    let cloneObjConfig = function(origin, target) {
        for(let attr in origin) {
            target[attr] = origin[attr];
        }
    }

    let isLogin = function() {
        return authorities && authorities.size;
    }

    let hasAuthor = function(author) {
        return authorities.has(author);
    }

    let isAuthorized = function(path) {
        let _isAuthorized = true;
        for(let authorCfg of authorizationMapper) {
            if(!(authorCfg.regex instanceof RegExp)) {
                console.log('author regex path undefined');
                continue;
            }
            if(authorCfg.regex.test(path) && typeof authorCfg.isAuthorized === "function") {
                _isAuthorized &= authorCfg.isAuthorized(hasAuthor);
            }
        }
        return _isAuthorized;
    }

    let authLogin = function(access_token, authoritiesStore, userName) {
        localStorage.setItem(ACCESS_TOKEN_NAME, access_token);
        localStorage.setItem(AUTHORRITIES_NAME, JSON.stringify(authoritiesStore));
        localStorage.setItem(USER_NAME, userName);
        initAuthorities();
        setupUserInfor();
        initAuthenSuccesUrlRedirect();
        route.push(authenSuccesUrlRedirect);
    }

    let authLogout = function() {
        authorities.clear();
        localStorage.clear();
        route.push({name:'UserLogin'});
    }

    let getAuthoritiesStore = function() {
        let authoritiesStore;
        try {
            let _authoritiesStr = localStorage.getItem(AUTHORRITIES_NAME);
            if(_authoritiesStr) {
                authoritiesStore = JSON.parse(_authoritiesStr);
            } else {
                authoritiesStore = []
            }
        } catch {
            authoritiesStore = [];
        }
        return authoritiesStore;
    }

    let getUserName = function() {
        return userName;
    }

    let setupUserInfor = function() {
       userName = localStorage.getItem(USER_NAME);
    }

    let init = function() {
        initAuthorities();
        initConfig();
        setupUserInfor();
        initRouteFilter();
    }

    init();

    return {
        roles: securityCfg.roles,
        getUserName: getUserName,
        hasAuthor: hasAuthor,
        isAuthorized: isAuthorized,
        isLogin: isLogin,
        authLogin: authLogin,
        authLogout : authLogout,
    }
})(route);

export function roles() {
    return security.roles;
}
export function getUserName() {
    return security.getUserName();
}
export function hasAuthor(author) {
    return security.hasAuthor(author);
}
export function isAuthorized(path) {
    return security.isAuthorized(path);
}
export function authLogin(access_token, authoritiesStore, userName) {
    return security.authLogin(access_token, authoritiesStore, userName);
}
export function authLogout() {
    return security.authLogout();
}
